/* Neubau D · Startseiten-Slider (sections/d-home-slider.liquid).
   Wischen macht der Browser (scroll-snap). Hier nur: aktive Kachel aus der Scroll-Lage lesen, Punkte/Zähler/Knöpfe nachziehen,
   Zurück/Weiter/Punkte und Pfeiltasten springen ohne Gleiten (behavior: 'instant'). Kein Selbstlauf.
   Rastet die Kachel mittig ein (Story-Reihe am Desktop), zählt die Mitte; ein Klick auf eine Nachbarkarte holt sie in die Mitte. */
(function () {
  function init(root) {
    if (root.dataset.khSlReady) return;
    root.dataset.khSlReady = '1';
    var track = root.querySelector('[data-kh-sl-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-kh-sl-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-kh-sl-dot]'));
    var prev = root.querySelector('[data-kh-sl-prev]');
    var next = root.querySelector('[data-kh-sl-next]');
    var now = root.querySelector('[data-kh-sl-now]');
    if (!track || slides.length < 2) return;
    var current = 0;

    function pad() { return parseFloat(getComputedStyle(track).scrollPaddingLeft) || 0; }
    function centered() { return /center/.test(getComputedStyle(slides[0]).scrollSnapAlign); }
    function target(s) { return centered() ? s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2 : s.offsetLeft - pad(); }
    function nearest() {
      var x = track.scrollLeft;
      var best = 0, dist = Infinity;
      slides.forEach(function (s, i) {
        var d = Math.abs(target(s) - x);
        if (d < dist) { dist = d; best = i; }
      });
      // Am Ende des Wegs zählt die letzte Kachel, auch wenn sie nicht ganz links einrastet
      if (track.scrollLeft + track.clientWidth >= track.scrollWidth - 2) best = slides.length - 1;
      return best;
    }
    function paint(i) {
      current = i;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
      // Punkte und Story-Leiste tragen beide data-kh-sl-dot; der Wert ist die Kachel
      dots.forEach(function (d) { if (Number(d.dataset.khSlDot) === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      if (now) now.textContent = String(i + 1);
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    function go(i) {
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: target(slides[i]), behavior: 'instant' });
      paint(i);
    }

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; var i = nearest(); if (i !== current) paint(i); });
    }, { passive: true });
    if (prev) prev.addEventListener('click', function () { go(current - 1); });
    if (next) next.addEventListener('click', function () { go(current + 1); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(Number(d.dataset.khSlDot)); }); });
    track.addEventListener('click', function (e) {
      var s = e.target.closest('[data-kh-sl-slide]');
      var k = slides.indexOf(s);
      if (!centered() || k < 0 || k === current) return;
      e.preventDefault();
      go(k);
    });
    root.addEventListener('keydown', function (e) {
      if (e.target.closest('input, textarea, select')) return;
      if (e.key === 'ArrowRight') { e.preventDefault(); go(current + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); go(current - 1); }
    });
    window.addEventListener('resize', function () { paint(nearest()); });
    paint(nearest());
  }
  function all() { document.querySelectorAll('[data-kh-sl]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  document.addEventListener('shopify:section:load', all);
})();
